import Image from '@/components/image';
import NextLink from '@/components/next-link';

const BrandsSlider = ({ info, isMobile, locale }) => {
  return (
    <NextLink href={info?.url || '#'}>
      <Image
        loading='lazy'
        src={
          isMobile ? info?.[`mobile-img-${locale}`] : info?.[`img-${locale}`]
        }
        className='h-16 w-24 scale-100 transform object-contain transition-all hover:scale-110 md:h-28 md:w-40'
        alt={info?.[`img-${locale}`]}
      />
    </NextLink>
  );
};

export default BrandsSlider;
